/* eslint-disable @typescript-eslint/quotes */
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { serverUrl } from "src/app/serverUrl";

@Injectable({
  providedIn: "root",
})
export class QuestionAnswerKeywordService {
  constructor(private httpClient: HttpClient) {}

  async getFaqQuestions(catId: any, sucId: any) {
    const formData = new FormData();
    formData.append("catId", catId);
    formData.append("sucId", sucId);
    const url = (await serverUrl) + "open/getFaqQuestions";
    return new Promise((resolve) => {
      this.httpClient
        .post(url, formData, {
          headers: new HttpHeaders().set("Content-Type", "application/x-www-form-urlencoded;charset=utf-8"),
        })
        .toPromise()
        .then((res) => {
          resolve(res);
        })
        .catch((resp: Response) => {
          resolve(resp);
        });
    });
  }

  getFaqQuestionsV1(catId: any, sucId: any): Observable<any> {
    let queryParams = new HttpParams();
    queryParams = queryParams.append("catId", catId);
    queryParams = queryParams.append("sucId", sucId);
    return this.httpClient.post<any>(serverUrl + "open/getFaqQuestions", queryParams, {
      headers: new HttpHeaders().set("Content-Type", "application/x-www-form-urlencoded;charset=utf-8"),
    });
  }

  async saveQuestion(
    catId: any,
    sucId: any,
    qusId: any,
    qusDescEng: any,
    qusDescMar: any,
    qusKeywordEng: any,
    qusKeywordMar: any,
    qusAnswerEng: any,
    qusAnswerMar: any,
    flag: any
  ) {
    const formData = new FormData();
    formData.append("catId", catId);
    formData.append("sucId", sucId);
    if (flag === "E") {
      formData.append("qusId", qusId);
    }

    formData.append("qusDescEng", qusDescEng);

    formData.append("qusDescMar", qusDescMar);
    formData.append("qusKeywordEng", qusKeywordEng);
    formData.append("qusKeywordMar", qusKeywordMar);
    formData.append("qusAnswerEng", qusAnswerEng);

    formData.append("qusAnswerMar", qusAnswerMar);

    const url = (await serverUrl) + "open/saveQuestion";
    return new Promise((resolve) => {
      this.httpClient
        .post(url, formData, {
          headers: new HttpHeaders().set("Content-Type", "application/x-www-form-urlencoded;charset=utf-8"),
          responseType: "text",
        })
        .toPromise()
        .then((res) => {
          resolve(res);
        })
        .catch((resp: Response) => {
          resolve(resp);
        });
    });
  }

  saveQuestionV1(
    catId: any,
    sucId: any,
    qusId: any,
    qusDescEng: any,
    qusDescMar: any,
    qusKeywordEng: any,
    qusKeywordMar: any,
    qusAnswerEng: any,
    qusAnswerMar: any,
    flag: any
  ): Observable<any> {
    let queryParams = new HttpParams();
    queryParams = queryParams.append("catId", catId);
    queryParams = queryParams.append("sucId", sucId);
    if (flag === "E") {
      queryParams = queryParams.append("qusId", qusId);
    }

    queryParams = queryParams.append("qusDescEng", qusDescEng);
    queryParams = queryParams.append("qusDescMar", qusDescMar);

    queryParams = queryParams.append("qusKeywordEng", qusKeywordEng);
    queryParams = queryParams.append("qusKeywordMar", qusKeywordMar);

    queryParams = queryParams.append("qusAnswerEng", qusAnswerEng);
    queryParams = queryParams.append("qusAnswerMar", qusAnswerMar);
    return this.httpClient.post<any>(serverUrl + "open/saveQuestion", queryParams, {
      headers: new HttpHeaders().set("Content-Type", "application/x-www-form-urlencoded;charset=utf-8"),
      responseType: "text" as "json",
    });
  }
}
